<template>
    <div
        v-if="previewModalVisible"
        class="fixed z-10 inset-0 overflow-y-auto"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
    >
        <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

            <!-- This element is to trick the browser into centering the modal contents. -->
            <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true" >&#8203;</span
            >

            <div class="inline-block align-bottom bg-white px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-6xl sm:w-full sm:p-6">
                <div>
                    <div class="mb-5 overflow-x-auto shadow-sm rounded">
                        <table class="w-full text-center text-sm">
                            <tr class="header bg-gray-50 px-6 py-3">
                                <th class="px-6 py-3" id="first_name">First Name</th>
                                <th class="px-6 py-3" id="last_name">Last Name</th>
                                <th class="px-6 py-3" id="email">Email</th>
                                <th class="px-6 py-3" id="company_type">Company Type</th>
                                <th class="px-6 py-3" id="gallery_access">Gallery Access</th>
                                <th class="px-6 py-3" id="country">Country</th>
                                <th class="px-6 py-3" id="company_name">Company Name</th>
                                <th class="px-6 py-3" id="distributor">Distributor</th>
                            </tr>
                            <tr v-for="(item, index) in importData" :key='index'>
                                <td class="px-6 py-4">{{ item[0] }}</td>
                                <td class="px-6 py-4">{{ item[1] }}</td>
                                <td class="px-6 py-4">{{ item[2] }}</td>
                                <td class="px-6 py-4">{{ item[3] }}</td>
                                <td class="px-6 py-4">{{ item[4] }}</td>
                                <td class="px-6 py-4">{{ item[5] }}</td>
                                <td class="px-6 py-4">{{ item[6] }}</td>
                                <td class="px-6 py-4">{{ item[7] }}</td>
                            </tr>
                        </table>
                    </div>

                    <div class="mt-5 sm:mt-6 flex space-x-4">
                        <button type="button" class="inline-flex justify-center w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded " @click="closePreviewModal()" >
                            Back to import
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <jet-form-section @submitted="importUsers">
        <template #title>
            Import Users
        </template>

        <template #description>
            <a href="/import-users.csv" target="_blank" rel="noopener noreferrer">Download sample csv here</a>
        </template>

        <template #form>

            <div class="col-span-6 sm:col-span-4">
                <input type="file" class="hidden" ref="csv" @change="updateFilePreview" accept=".csv">

                <jet-label for="csv" value="CSV" />

                <p v-if="filePreview">
                    File: {{ filePreview }}
                    (<a class="underline cursor-pointer" @click="showPreviewModal()">preview</a>)
                </p>

                <jet-secondary-button class="mt-2 mr-2" type="button" @click.prevent="selectCSV">
                    {{ ctaLabel }}
                </jet-secondary-button>
            </div>
        </template>

        <template #actions>
            <jet-action-message :on="form.recentlySuccessful" class="mr-3">
                Import Successfully.
            </jet-action-message>

            <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                Import
            </jet-button>
        </template>
    </jet-form-section>
</template>

<script>
    import JetActionMessage from '@/Jetstream/ActionMessage'
    import JetSecondaryButton from '@/Jetstream/SecondaryButton'
    import JetButton from '@/Jetstream/Button'
    import JetFormSection from '@/Jetstream/FormSection'
    import JetLabel from '@/Jetstream/Label'

    export default {
        components: {
            JetActionMessage,
            JetSecondaryButton,
            JetButton,
            JetFormSection,
            JetLabel,
        },

        data() {
            return {
                filePreview: '',
                previewModalVisible: false,
                ctaLabel: 'Select CSV File',
                form: this.$inertia.form({
                    csv: null,
                }),
                importData: []
            }
        },

        methods: {
            selectCSV() {
                this.$refs.csv.click();
            },
            updateFilePreview() {
                this.filePreview = this.$refs.csv.files[0].name;
                this.form.csv = this.$refs.csv.files[0];

                let _this = this;
                let reader = new FileReader();
                reader.onload = function(e) {
                    let csvData = [];
                    let text = e.target.result;
                    let lines = text.split(/[\r\n]+/g); // tolerate both Windows and Unix linebreaks

                    for (let i = 0; i < lines.length; i++) {
                        let line = [];
                        let arrayData = lines[i].split(",");
                        for (let o = 0; o < arrayData.length; o++) {
                            let value = arrayData[o];
                            if (value === "") value = "-";
                            if (value === "1") value = "Yes";
                            if (value === "0") value = "No";
                            line.push(value);
                        }

                        if (arrayData.length > 1 && i != 0) csvData.push(line);
                    }

                    _this.importData = csvData;
                };
                reader.readAsText(this.form.csv,"UTF-8");
            },
            getFilePreview() {
            },
            showPreviewModal() {
                this.previewModalVisible = true;
            },
            closePreviewModal() {
                this.previewModalVisible = false;
            },
            importUsers() {
                this.form.post(route('import-users.import'), {
                    errorBag: 'saveBD',
                    preserveScroll: true,
                    onSuccess: () => this.importSuccess(),
                    // onError: () => this.getBrandDrivers()
                })
            },
            importSuccess() {
                this.filePreview = '';
                this.ctaLabel = "Select Another CSV File";
            },
        },
    }
</script>
